/// <reference types="vite/client" />
import { type FirebaseApp, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

/**
 * Initialize Firebase with runtime configuration
 * This function should be called after the config is loaded
 */
export const initializeFirebase = (config: { FBASE_API_KEY: string; FBASE_AUTH_DOMAIN: string; FBASE_PROJECT_ID: string }) => {
    if (app) {
        console.warn('Firebase already initialized');
        return { app, auth: auth! };
    }

    const firebaseConfig = {
        apiKey: config.FBASE_API_KEY,
        authDomain: config.FBASE_AUTH_DOMAIN,
        projectId: config.FBASE_PROJECT_ID,
    };

    app = initializeApp(firebaseConfig);
    auth = getAuth(app);

    return { app, auth };
};

/**
 * Get Firebase auth instance
 * Must be called after initializeFirebase
 */
export const getFirebaseAuth = (): Auth => {
    if (!auth) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return auth;
};

/**
 * Get Firebase app instance
 * Must be called after initializeFirebase
 */
export const getFirebaseApp = (): FirebaseApp => {
    if (!app) {
        throw new Error('Firebase not initialized. Call initializeFirebase first.');
    }
    return app;
};

/**
 * Default export for convenience
 */
export default app;
